<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document" @click.stop>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('iniciarConversaModal.titulo') }}</h5>
          <button type="button" class="btn-close" @click="$emit('fechar')"></button>
        </div>
        <div class="modal-body">
          <input
            v-model="busca"
            @input="buscarUsuarios"
            type="text"
            class="form-control mb-3"
            :placeholder="$t('iniciarConversaModal.placeholderBusca')"
          />

          <div v-if="usuarios.length === 0 && busca.length > 2">
            <small>{{ $t('iniciarConversaModal.nenhumUsuario') }}</small>
          </div>

          <ul class="list-group">
            <li
              v-for="usuario in usuarios"
              :key="usuario.id"
              class="list-group-item d-flex justify-content-between align-items-center"
            >
              <div class="d-flex align-items-center">
                <img
                  :src="usuario.links?.find(l => l.rel === 'foto')?.href || require('../../assets/img/user-icon.png')"
                  alt="avatar"
                  class="rounded-circle me-2"
                  style="width: 32px; height: 32px"
                />
                <span>{{ usuario.nome }}</span>
              </div>
              <button
                class="btn btn-sm btn-primary"
                :disabled="verificarConversaExistente(usuario.id)"
                @click="iniciarConversa(usuario.id)"
              >{{ $t('iniciarConversaModal.conversar') }}</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useUserStore } from '@/utils/stores/userStore';

export default {
  name: 'IniciarConversaModal',
  props: {
    conversasExistentes: Array
  },
  data() {
    return {
      busca: '',
      usuarios: [],
      token: ''
    };
  },
  mounted() {
    this.usuarioId = useUserStore().id;
    this.token = useUserStore().token;
  },
  methods: {
    async buscarUsuarios() {
      if (this.busca.length < 3) {
        this.usuarios = [];
        return;
      }
      try {
        const res = await axios.get(
          `${this.$dominio}/api/colaboradores?string=${encodeURIComponent(this.busca)}&page=0&size=10`,
          {
            headers: { Authorization: `Bearer ${this.token}` }
          }
        );
        this.usuarios = res.data.colaboradores.filter(u => u.id !== this.usuarioId);
      } catch (err) {
        console.error('Erro ao buscar usuários:', err);
        this.usuarios = [];
      }
    },
    verificarConversaExistente(idOutroUsuario) {
      return this.conversasExistentes?.some(chat => {
        if (chat.nome !== 'CHATROOM__1:1') return false;

        const ids = chat.assinantes.map(a => {
          const partes = a.assinanteURI.split('/');
          return parseInt(partes[partes.length - 1]);
        });

        return ids.includes(this.usuarioId) && ids.includes(idOutroUsuario);
      });
    },
    async iniciarConversa(idOutroUsuario) {
      try {
        const payload = {
          assinantes: [
            { id: this.usuarioId },
            { id: idOutroUsuario }
          ]
        };
        const res = await axios.post(`${this.$dominio}/api/chats`, payload, {
          headers: { Authorization: `Bearer ${this.token}` }
        });

        // Extrai o resourceURI
        const location = res.data.resourceURI;

        // Busca os dados completos da nova sala
        const respostaSala = await axios.get(location, {
          headers: { Authorization: `Bearer ${this.token}` }
        });

        const novaSala = respostaSala.data;

        console.log('Nova sala carregada:', novaSala);

        // Emite para o ChatApp.vue
        this.$emit('novaSalaCriada', novaSala);
        this.$emit('fechar');
      } catch (err) {
        console.error('Erro ao iniciar conversa:', err);
      }
    }
  }
};
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.5);
}

/* Modais do chat acima do chat-container */
.modal {
  z-index: 10000 !important;
}

.modal-backdrop {
  z-index: 9999 !important; /* logo abaixo do modal, mas ainda acima do overlay */
}
</style>
